// compose higher order functions from right to left. i.e. enhancing dumb components
export const compose =
  <T>(...fns: ((arg: T) => any)[]) =>
  (x: T) =>
    fns.reduceRight((v, f) => f(v), x);

/**
 * memoizes a function -- won't invoke function unless argument has changed. useful for onChange validators
 * @param func: function to memoize
 */
export const memoize = <A, R>(
  func: (...args: A[]) => R,
): ((...args: A[]) => R) => {
  let prevArgs: A[] = [];
  let prevResult: R;
  return (...args: A[]) => {
    const argsDidChange =
      prevArgs.length !== args.length ||
      prevArgs.some((arg, index) => arg !== args[index]);

    if (argsDidChange) {
      prevArgs = args;
      prevResult = func(...args);
    }

    return prevResult;
  };
};

export const sleep = (millis: number) =>
  new Promise(resolve => setTimeout(resolve, millis));
